const d=()=>"undefined"!=typeof window&&void 0!==window.document;export{d as default};
//# sourceMappingURL=isBrowser.js.map
